import { Flex } from '@applyboard/crystal-ui';
import { CheckCircleOutlineIcon } from '@applyboard/ui-icons';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function SuccessMessage(_ref) {
  var children = _ref.children;
  return _jsxs(Flex, {
    gap: 4,
    children: [_jsx(CheckCircleOutlineIcon, {
      size: "xl",
      intent: "positive"
    }), _jsx(Flex, {
      direction: "column",
      gap: 4,
      children: children
    })]
  });
}